'use strict';

angular
  .module('AdminSupervisorReviewControllers')

  .controller('ActionOnCardsSupervisorCtrl', [
    '$scope',
    '$modal',
    '$translate',
    'adminSupervisorReviewService',
    function ($scope, $modal, $translate, administrationService) {
      var ADDITIONAL_REV = 'Additional Review';
      var NOT_STARTED = 'Not Started';
      var IN_PROGRESS = 'In Progress';
      var ADDITIONAL_REV = 'Additional Review';
      var COMPLETE = 'Complete';

      //Buttons on card
      $scope.displayActions = false;
      $scope.displayAlert = $scope.system.IamDisableNotification;
      $scope.labelStatusCard = $scope.system.Status;

      $scope.showOrHideActions = function (status, index) {
        $scope.displayActions = !$scope.displayActions;
        $scope.displayAdditionalReview = status === ADDITIONAL_REV;
        $scope.currentBadgeIdx = index;
      };

      $scope.labelStatusCard = null;
      if ($scope.system.Status == NOT_STARTED) $scope.labelStatusCard = 'label label-gray';

      if ($scope.system.Status == COMPLETE) $scope.labelStatusCard = 'label label-green';

      if ($scope.system.Status == IN_PROGRESS) $scope.labelStatusCard = 'label label-blue';

      if ($scope.system.Status == ADDITIONAL_REV) $scope.labelStatusCard = 'label label-orange';

      var supervisorModal;

      $translate('iam.admin.supervisorReview.modal.sendReminder.title').then(function (translation) {
        supervisorModal = $modal({
          scope: $scope,
          template: require('./ConfirmDialogSupervisorReminder.tpl.html'),
          title: translation,
          placement: 'center',
          controller: 'ActionOnCardsSupervisorCtrl',
          show: false,
        });
      });

      $scope.showconfirmdialog = function () {
        supervisorModal.$promise.then(supervisorModal.show);
      };

      $scope.impersonateSupervisor = function () {
        window.open('/AccessReview/' + $scope.system.ActiveDirectoryAccountUsername, '_blank');
      };

      $scope.submitSupervisorReminder = function (emailToSend) {
        administrationService.submitSupervisorReminder(emailToSend, $scope.system.EmployeeID);
        supervisorModal.$promise.then(supervisorModal.hide);
      };

      $scope.AdditionalReviewRequired = function () {
        administrationService
          .createAdditionalAccessReview($scope.system.AccessReviewID, $scope.system.EmployeeID)
          .then(function (updateBadge) {
            $scope.systemsAndSysRoles[$scope.currentBadgeIdx] = updateBadge.data;
          });
      };
    },
  ]);
